module.exports = __webpack_public_path__ + "static/img/quesheng1.02aa6bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quesheng1.png
// module id = rO9v
// module chunks = 1